
export default {
    name: 'rapport-annulation',
    components: {},
    props: {
        rapport_annulations: Array,
        by_prestation: String,
        modal_toggler: Number
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, "patient",  { key: 'montant', label: 'Montant' }
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            annulation_len: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.refreshAnnulation()
            this.filter = this.by_prestation
        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {
        refreshAnnulation() {
            if (this.rapport_annulations) {
                this.annulation_len = this.rapport_annulations.length
            }
        }
    }
}